import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarVerracos`, method: 'POST', body: value, token: token})
}
